import './CommonSearchBox.less';

import { fireGAEvent } from '@/analytics';
import { scrollBody } from '@/common/client';
import clsx from 'clsx';
import SearchForm from '@/common/components/search-form/SearchForm';
import i18n from '@i18n';
import SearchView from '@/fullsearch/views/SearchView';
import React, { ReactNode } from 'react';

function CommonSearchBox({
    children,
    visible,
    searchText,
    change,
    submit,
    onClose,
    betbookActive,
    formRef
}: {
    children: ReactNode;
    visible: boolean;
    searchText: string;
    change: (value: string) => any;
    submit: (value: string) => any;
    onClose: () => any;
    betbookActive?: boolean;
    formRef?: React.MutableRefObject<any>;
}) {
    function close() {
        fireGAEvent('Vyhladavanie', 'Zrusit vyhladavanie');
        onClose();
        scrollBody(true);
    }
    return (
        <div className={clsx('search-fixer', { visible })}>
            <div className="search-container">
                <SearchForm
                    ref={formRef}
                    value={searchText}
                    placeholder={i18n('search.input.size')}
                    onChange={change}
                    onSubmit={submit}
                />
                {betbookActive ? null : (
                    <button className="cancel" onClick={close} data-atid="search-close">
                        {i18n('commons.button.zrusit')}
                    </button>
                )}
            </div>
            <SearchView>{children}</SearchView>
        </div>
    );
}

export default CommonSearchBox;
